import { Box, Grid, Skeleton } from '@mui/material';
import React from 'react';

interface SectionSkeletonProps {
  rowsPerColumn?: number;
}

const SectionSkeleton: React.FC<SectionSkeletonProps> = ({
  rowsPerColumn = 4,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {/* Header skeleton */}
      <Box
        sx={{
          backgroundColor: 'rgba(128, 128, 128, 0.08)',
          borderRadius: '8px',
          px: 1.5,
          py: 0.8,
        }}
      >
        <Skeleton variant="text" width={150} height={20} sx={{ mx: 'auto' }} />
      </Box>
      {/* Content skeleton */}
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          {[...Array(rowsPerColumn)].map((_, index) => (
            <Box
              key={`left-${index}`}
              display="flex"
              alignItems="center"
              gap={1}
              sx={{ mb: 1.5 }}
            >
              <Skeleton
                variant="circular"
                width={24}
                height={24}
                sx={{ flexShrink: 0 }}
              />
              <Box sx={{ flex: 1, minWidth: 120 }}>
                <Skeleton
                  variant="text"
                  width={100}
                  height={14}
                  sx={{ mb: 0.2 }}
                />
                <Skeleton variant="text" width={80} height={18} />
              </Box>
            </Box>
          ))}
        </Grid>
        <Grid item xs={12} md={6}>
          {[...Array(rowsPerColumn)].map((_, index) => (
            <Box
              key={`right-${index}`}
              display="flex"
              alignItems="center"
              gap={1}
              sx={{ mb: 1.5 }}
            >
              <Skeleton
                variant="circular"
                width={24}
                height={24}
                sx={{ flexShrink: 0 }}
              />
              <Box sx={{ flex: 1, minWidth: 120 }}>
                <Skeleton
                  variant="text"
                  width={100}
                  height={14}
                  sx={{ mb: 0.2 }}
                />
                <Skeleton variant="text" width={80} height={18} />
              </Box>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default SectionSkeleton;
